import { atom } from "jotai";
import { atomWithStorage } from "jotai/utils";

// Whether the search overlay is visible. Shared by header/footer triggers
// and the SearchPanel itself.
export const isSearchPanelOpenAtom = atom(false);

// Recent search terms persisted to localStorage. Capped + deduped by the
// useRecentSearches hook. Keeping persistence at the atom layer means we can
// later swap atomWithStorage for a backend-backed atom without touching UI.
export const recentSearchesAtom = atomWithStorage<string[]>(
    "usnara.recentSearches",
    [],
);
